
$(document).on("click", ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').removeClass('active');
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});
$(document).on("click", ".custom-play-button", function (e) {
    var video = $(this).parents('.video-wrapper').find('video');

    if ($(this).hasClass("active")) {
        $(this).parents('.video-wrapper').removeClass('video-active');
        $(this).removeClass('active');
        video.trigger('pause');
    } else {
        video.trigger('play');
        $(this).parents('.video-wrapper').addClass('video-active');
        $(this).addClass('active');
    }
});

// Click on video to pause
$(document).on("click", ".video-wrapper video", function () {
    var wrapper = $(this).parents('.video-wrapper');
    var button = wrapper.find(".custom-play-button");

    $(this).trigger('pause');
    wrapper.removeClass('video-active');
    button.removeClass('active');
});







$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", "a[href='#why']", function (e) {
  e.preventDefault();
  document.querySelector('#why').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='/#why']", function (e) {
 if( $('#why').length ){
  e.preventDefault();
  document.querySelector('#why').scrollIntoView({
    behavior: 'smooth'
  })
 }
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='/#reviews']", function (e) {
 if( $('#reviews').length ){
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
 }
});
$(document).on("click", ".redirect-cart", function (e) {
location.href='/cart';
});

jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
 jQuery('body').addClass('window-os'); 
}
});





function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 1000,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });

});
async function flag() {
    const response = await fetch('/browsing_context_suggestions.json');
    const data = await response.json();
    const countryCode = data.detected_values.country.handle.toLowerCase();

    var flag_link =  'https://www.worldometers.info//img/flags/small/tn_'+countryCode+'-flag.gif';
    $('span.site-nav__link.site-nav__link--icon.desktop_flag_wrapper img').attr('src',flag_link);
}
//flag();
$(document).ready(function(){

//flag();
});
 